import React from "react"
// import { graphql } from "gatsby"
import { Helmet } from "react-helmet"

export default function Seo() {
  //   const { title, description, image, host } = site
  const title = `Dalti | Votre Sallon, Notre Meilleure Salle D'attente`
  const description = `DALTI SOLUTION est un software as a service, en marque blanche, permettant aux entreprises de réinventer leur façon de penser et manager leurs relations clients et employés (customer & employee care) !`
  return (
    <Helmet title={title}>
      <meta name="description" content={description} />
      <meta name="image" content="/hero.png" />
      {
        // open graph card
      }
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content="/hero.png" />
      <script
        async
        defer
        src="https://static.cdn.prismic.io/prismic.js?new=true&repo=dalti"
      ></script>
    </Helmet>
  )
}
